import React from "react";
import Headerdash from "./head";
import Sidebar from "./sidebar";
import { useState, useEffect } from "react";
import PageNavigation from "./page";



export default function WriteEssay() {

  const [writeEssayData, setWriteEssayData] = useState({
    data: [],
  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchWriteEssay = async () => {
      try {
        const response = await fetch("/api/questions/writeessay", {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (response.ok) {
          const data = await response.json();

          setWriteEssayData({
            data: data,
          });

          console.log("Data:", data);
        } else {
          console.error(
            "Failed to fetch writeEssay data. Status:",
            response.status
          );
        }
      } catch (error) {
        console.error("Error fetching writeEssay data:", error);
      } finally {
        setLoading(false); // Set loading to false regardless of success or failure
      }
    };

    fetchWriteEssay();
  }, []); // Empty dependency array to fetch data only once on mount
  return (
    <div>
      <Headerdash />
      <Sidebar />
      <PageNavigation heading=" Write Essay " id={writeEssayData.data}/>
    </div>
  );
}
